import React, { useMemo } from "react";
import { Box } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { ToggleButtonGroup, ExportButton } from "components";
import { getEmissionsExport } from "api";
import { SITE_EMISSIONS_COLUMNS_MAIN } from "./columns";

export const EmissionTableComponent = ({
  complementaryColumns = [],
  isDisaggregated,
  setIsDisaggregated,
  tableData,
  exportParams,
}: {
  complementaryColumns?: any;
  isDisaggregated: boolean;
  setIsDisaggregated: (isDisaggregated: boolean) => void,
  tableData: any;
  exportParams?: any;
}) => {

  const columns = useMemo(
    () => [...SITE_EMISSIONS_COLUMNS_MAIN, ...complementaryColumns],
    [complementaryColumns]
  );

  const toggleOptions = [
    { value: 'Aggregated', label: 'Aggregated' },
    { value: 'Monthly', label: 'Monthly' }
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 3, width: "100%" }}>
      <Box sx={{ display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}>
        <ToggleButtonGroup
          options={toggleOptions}
          selectedValue={isDisaggregated ? "Monthly" : "Aggregated"}
          onValueChange={(value) => setIsDisaggregated(value === "Monthly")}
        />
        {exportParams && (
          <ExportButton
            exportFunction={getEmissionsExport}
            exportParams={exportParams}
            exportText="Export CSVs"
            exportTitle="emissions_summary_export"
            exportingText="Exporting..."
            successMessage="Export completed successfully."
            errorMessage="Failed to export emissions data."
            isZipFile={false}
            fileExtension=".csv"
            sx={{
              width: '200px',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: "500"
            }}
          />
        )}
      </Box>
      <MaterialReactTable
        columns={columns}
        data={tableData}
        enableTopToolbar
        muiTableContainerProps={{
          sx: {
            "& thead tr:first-of-type th:first-of-type": {
              paddingLeft: "20px",
            },
            "& tbody tr td:first-of-type": {
              paddingLeft: "20px",
            },
            "& tbody tr:first-of-type td > p": {
              display: "flex",
              width: "100%",
              justifyContent: "center",
            },
            height: "calc(100vh - 375px)",
            border: "1px solid #D9D9D9",
            borderRadius: "10px",
            width: "100%",
          },
        }}
        muiTablePaperProps={{
          sx: {
            borderRadius: "10px",
            boxShadow: "none",
          },
        }}
        muiTopToolbarProps={{
          sx: {
            height: '1px',
            minHeight: '1px',
            backgroundColor: 'transparent',
            '& .MuiIconButton-root': {
              display: 'none',
            },
          },
        }}
        muiBottomToolbarProps={{
          sx: {
            display: "none",
          },
        }}
        muiTableHeadCellProps={{
          sx: {
            lineHeight: "30px",
            "& .MuiBadge-root": {
              display: "none",
            },
          },
        }}
        muiTableHeadRowProps={{
          sx: {
            "& > th:first-of-type": {
              paddingLeft: "20px",
            },
            "& > th": {
              paddingTop: 1,
              paddingBottom: 1,
            },
            height: "auto",
            backgroundColor: "#F8FAFC",
          },
        }}
        enableColumnResizing
        enableDensityToggle={false}
        initialState={{ density: "compact" }}
        enablePagination={false}
        enableRowVirtualization
        enableGrouping
      />
    </Box>
  )
}
